import React from 'react';
import { WebUiButton } from 'src/modules/web-ui/components/button';
import { WebUiInput } from 'src/modules/web-ui/components/input';
import { twMerge } from 'tailwind-merge';

type CircuitPort = { port_id: number; circuit_id: string };
type InserterSubnet = { vid: number; ports: CircuitPort[] };

function ifaceName(vid: number): string {
  return vid === 0 ? 'Lan' : `VLAN_ID${vid}`;
}

function portName(portId: number): string {
  return `Port ${portId + 1}`;
}

export default function DhcpInserterSubnetEditor({
  subnets,
  openedVid,
  readonly,
  setOpenedVid,
  setSubnets,
  setCircuitIds,
}: {
  subnets: InserterSubnet[];
  openedVid: number | null;
  readonly: boolean;
  setOpenedVid: (vid: number) => void;
  setSubnets: React.Dispatch<React.SetStateAction<InserterSubnet[]>>;
  setCircuitIds: (vid: number) => void;
}) {
  if (!subnets.length) {
    return (
      <div className="text-[12px]">No inserter subnet configuration found.</div>
    );
  }

  return (
    <div className="flex flex-col gap-0">
      <div className="mb-2 flex flex-wrap gap-2 p-1">
        {subnets.map((s) => (
          <WebUiButton
            key={s.vid}
            onClick={() => setOpenedVid(s.vid)}
            className={twMerge([
              'px-2 py-1 text-sm',
              openedVid === s.vid ? 'bg-webui-primary' : 'bg-transparent',
            ])}
          >
            {ifaceName(s.vid)}
          </WebUiButton>
        ))}
      </div>
      {subnets.map((s) =>
        openedVid === s.vid ? (
          <div key={s.vid} className="border border-webui-border p-2">
            <table className="webui-table w-full">
              <thead>
                <tr className="webui-table-row-head">
                  <td>Option</td>
                  <td>Setting</td>
                </tr>
              </thead>
              <tbody>
                {s.ports.map((p) => (
                  <tr
                    key={`${s.vid}-${p.port_id}`}
                    className="webui-table-row-content"
                  >
                    <td>{portName(p.port_id)} Circuit Port ID</td>
                    <td>
                      <WebUiInput
                        inputSize="sm"
                        className="w-full"
                        disabled={readonly}
                        value={p.circuit_id ?? ''}
                        onChange={(e) =>
                          setSubnets((prev) =>
                            prev.map((sub) =>
                              sub.vid !== s.vid
                                ? sub
                                : {
                                    ...sub,
                                    ports: sub.ports.map((port) =>
                                      port.port_id === p.port_id
                                        ? {
                                            ...port,
                                            circuit_id: e.target.value,
                                          }
                                        : port,
                                    ),
                                  },
                            ),
                          )
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="mt-2">
              <WebUiButton
                disabled={readonly}
                onClick={() => setCircuitIds(s.vid)}
              >
                Set Circuit IDs for VLAN ID {s.vid}
              </WebUiButton>
            </div>
          </div>
        ) : null,
      )}
    </div>
  );
}
